import type { QueryClient } from "@tanstack/react-query";
import { ClassEnrollmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchClassesEnrollmentsByStudentIds(
  queryClient: QueryClient,
  studentIds: number[],
  accessToken: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching enrollments");
  }

  if (studentIds.length === 0) {
    return queryClient;
  }

  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  const sortedIds = [...new Set(studentIds)].sort((a, b) => a - b).join(",");

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.ClassesEnrollmentsByStudentId,
      "multiple",
      sortedIds,
    ],
    queryFn: () =>
      service.apiClassEnrollmentsStudentsGet({
        ids: studentIds,
        page: 1,
        pageSize: 1000,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}

